import base from "@/fstore";
import validation from "@/fstore/validation";

const db = base.db;
const collection = "jobtitles";
const model = db.collection(collection);

const template = {
  name: {
    type: 'string',
    required: true
  },
  dateAdded: {
    type: 'object',
    default: new Date()
  },
  active: {
    type: 'boolean',
    default: true
  },
  addedBy: {
    type: 'object',
    required: true
  }
}

const _getNullValueForField = (field) => {
  switch (template[field].type) {
    case "string":
      return "";
    case "object":
      return {};
    default:
      return null;
  }
}

const getTemplate = () => {
  const data = {}
  for (const field in template) {
    if (template[field].required)
      data[field] = _getNullValueForField(field);
    else
      data[field] = template[field].default;
  }

  return data;
}

const create = async position => {
  // verify that the doc doesn't already exist
  const check = await model.where('name', '==', position.name).get();

  if (!check.empty) {
    return new Error({ code: 422, message: `Position ${position.name} already exists` });
  }

  const response = await validation.validateModel(model, position, template);

  if (!response.errors.length) await model.add(response.doc);

  return response;
}

// gets a list of all job title names in the collection
const getActive = async () => {
  const refs = await model.where('active', '==', true).orderBy('name').get()
  return refs.docs.map(doc => doc.data().name);
}

const remove = async (uid) => {
  await model.doc(uid).set({active: false}, {merge: true});
}


export default {
  create,
  getActive,
  remove,
  getTemplate
}